<template>
  <v-container pb-0>
    <v-row no-gutters>
      <v-col cols="12" sm="6" md="6" lg="8" :class="$vuetify.breakpoint.smAndUp?'px-1':''">
        <v-card>
          <gmap-map id="map" ref="map" :options="mapOptions" :center="{
                    lat: (((userProfile || {}).location || {}).coords || {})[0] || 0,
                    lng: (((userProfile || {}).location || {}).coords || {})[1] || 0,
                  }" :zoom="11" :style="`height:${$vuetify.breakpoint.smAndDown?199:$vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-105:$vuetify.breakpoint.height-410}px`">
            <template v-for="(job, index) in filteredJobs">
              <gmap-marker :key="index" :position="{
                        lat: job.location[0] + randLat,
                        lng: parseFloat(job.location[1] + randLong),
                      }" :icon="processIcon(job)" :clickable="true" @click="mapClick(job)" />
            </template>
            <gmap-marker :position="{
                      lat: (((userProfile || {}).location || {}).coords || {})[0] || 0,
                      lng: (((userProfile || {}).location || {}).coords || {})[1] || 0,
                    }" />
          </gmap-map>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="4" :class="$vuetify.breakpoint.smAndUp?'px-1':''">
        <v-card class="px-1" flat tile>
          <v-row no-gutters>
            <div :class="`mt-1 custom-input v-input v-input--is-label-active v-input--is-dirty v-input--dense ${$vuetify.theme.dark?'theme--dark':'theme--light'} v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined`">
              <div class="v-input__control" style="height:40px">
                <div :class="`v-input__slot pr-1 `">
                  <v-icon medium color="primary lighten-1">map</v-icon>
                  <gmap-autocomplete ref="searchAdd" :class="`v-text-field__slot pt-4 px-2`" :label="$language.addJob['Job Address']" :placeholder="$language.addJob['Enter Job Address']" @place_changed="getAddressData" @focus="$event.target.select()">
                  </gmap-autocomplete>
                  <v-icon medium color="primary lighten-1" class="pr-1" @click="clear">cancel</v-icon>
                </div>
              </div>
            </div>
          </v-row>
          <v-row no-gutters align="end" class="pt-1">
            <v-col cols="6" justify="end" class="">
              <span :class="`pl-1 caption`"><span class="subheading">{{ filteredJobs.length }} </span>Jobs within
                {{ location.distance }} miles.</span>
            </v-col>
            <v-col cols="6" align="end" justify="end">
              <v-btn color="primary" icon text @click="asc = !asc">
                <v-icon v-if="asc">fa-sort-amount-up</v-icon>
                <v-icon v-if="!asc">fa-sort-amount-down</v-icon>
              </v-btn>
              <v-btn text icon color="primary" @click="changeView(false)" v-if="listView" class="mx-2">
                <v-icon large>view_stream</v-icon>
              </v-btn>
              <v-btn text icon color="primary" @click="changeView(true)" v-if="!listView" class="mx-2">
                <v-icon large>list</v-icon>
              </v-btn>
              <v-btn text icon color="primary" @click="handlePanel">
                <v-icon color="primary" size="22">fa-filter</v-icon>
              </v-btn>
            </v-col>

          </v-row>

          <v-col cols="12" class="pa-0">

            <v-expansion-panels v-model="filterPanel">
              <v-expansion-panel expand v-model="filterPanel">
                <v-expansion-panel-content>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="title font-weight-bold ">
                            Categories
                          </v-list-item-title>
                          <v-row no-gutters align="end">
                            <v-select multiple v-model="selectedCategories" :items="selectedCategories" hide-details outlined class="mb-1 custom" read-only @click="catSelectDialog = true">
                              <template slot="selection" slot-scope="{item, index}">
                                <v-chip v-if="index < 5" color="primary" small class="white--text font-weight-bold caption">
                                  <span>{{ item }}</span>
                                </v-chip>
                                <span v-if="index === 5">(+{{ selectedCategories.length - 5 }}
                                  {{ $language.jobSearch['others'] }})</span>
                              </template>
                            </v-select>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="title font-weight-bold ">
                            Distance (mi.)
                          </v-list-item-title>
                          <v-row no-gutters align="end">
                            <v-select dense outlined single-line v-model="location.distance" :items="distance" @change="changeDistance" hide-details></v-select>
                          </v-row>
                        </v-list-item-content>

                      </v-list-item>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="title font-weight-bold ">
                            Sort By
                          </v-list-item-title>
                          <v-row no-gutters align="end">
                            <v-select dense outlined single-line v-model="sort" :items="sortOptions" hide-details></v-select>
                          </v-row>
                        </v-list-item-content>

                      </v-list-item>
                    </v-col>
                    <v-col cols="12">
                      <v-list-item>
                        <v-list-item-content>
                          <v-row class="pl-1">
                            <v-chip class="mx-2 mb-2" :color="openBid?'primary':''" @click="openBid =!openBid">Open Bid</v-chip>
                            <v-chip class="mx-2 mb-2" :color="repeat?'primary':''" @click="repeat =!repeat">Repeat</v-chip>
                          </v-row>

                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row no-gutters>
                    <v-col cols="12" class="pt-4">
                      <v-btn color="primary" text block @click="handlePanel">done</v-btn>

                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <v-divider class="my-1"></v-divider>

          <v-expand-transition>

            <!-- CARD VIEW -->

            <v-virtual-scroll bench="10" :items="filteredJobs" :height="$vuetify.breakpoint.smAndDown?$vuetify.breakpoint.height-425:$vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-200:$vuetify.breakpoint.height-410" item-height="235" v-if="!listView&&filteredJobs.length>0">
              <template v-slot="{ item }">
                <job-list-item :key="item._key" :is-invite="true" :from-search="true" :from-dashboard="false" :job-data="item"></job-list-item>
              </template>
            </v-virtual-scroll>

            <!-- LIST VIEW -->

            <v-virtual-scroll bench="10" :items="filteredJobs" :height="$vuetify.breakpoint.smAndDown?$vuetify.breakpoint.height-425:$vuetify.breakpoint.mdAndUp?$vuetify.breakpoint.height-200:$vuetify.breakpoint.height-410" item-height="80" v-if="listView&&filteredJobs.length>0">
              <template v-slot="{ item }">
                <v-list-item :key="item._key" @click.native="$router.push({path: `/obrero/job-details/${item._key}?tab=Summary`})">
                  <v-list-item-content>
                    <v-list-item-title class="title">{{ item.title }} <span class="caption">({{item.dist}} mi)</span> </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-layout align-center justify-start>
                        <span>{{ item.startDate | formatShortDate }}
                          {{ item.startTime | formatTime }}
                          <span class="caption">
                            ({{ item | formatDateTime }})</span></span>
                      </v-layout>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <span v-if="!item.bid">${{ item.compensation }} {{ item.rateType === 'Hourly' ? $language.jobListItem['per hour'] : ''}}</span>
                    <span v-else>Open Bid</span>

                    <v-layout>
                      <v-icon medium v-if="item.repeat">refresh</v-icon>
                      <v-img :src="require(`@/assets/${item.category}.svg`)" height="24px" width="24px" contain />
                    </v-layout>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>

          </v-expand-transition>

          <v-row align="center">
            <v-col cols="12" align="center" justify="center" v-if="filteredJobs.length === 0">
              <div class="text-xs-center">
                {{ $language.jobSearch['There are no jobs to show at the moment.'] }}
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-flex v-if="status.loading.jobs">
        <v-layout fill-height column justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
          <h4 class="mt-3">{{ $language.jobSearch['Searching for jobs'] }}</h4>
        </v-layout>
      </v-flex>

      <v-dialog v-model="catSelectDialog" scrollable modal :overlay="false" max-width="500px" transition="dialog-transition">
        <v-card>
          <v-layout wrap class="pa-4 pb-0">
            <template v-for="(category, index) in categories">
              <v-flex xs6 :key="category + index">
                <v-checkbox class="ma-0 mb-1 pa-1" hide-details :key="category._key" v-model="selectedCategories" :value="category._key">
                  <template v-slot:label>
                    <v-row no-gutters align="center">
                      <v-col cols="2">
                        <v-img :src="require(`@/assets/${category._key}.svg`)" height="24px" cover></v-img>

                      </v-col>
                      <v-col cols="9">
                        <span class="pl-2">
                          {{category._key}}</span>
                      </v-col>
                    </v-row>

                  </template>
                </v-checkbox>
              </v-flex>
            </template>
            <v-flex xs12>
              <v-layout wrap align-center justify-center>
                <v-btn color="primary" text @click="selectAll" v-if="categories.length !== selectedCategories.length">Select all</v-btn>
                <v-btn color="primary" text @click="selectAll" v-if="categories.length === selectedCategories.length">Deselect all</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="handleSelectClose">Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import JobListItem from '@/components/common/JobListItem'
import { gmapApi } from 'vue2-google-maps'
const fb = require('@/services/firebaseConfig.js')
export default {
  components: {
    JobListItem
  },
  data () {
    return {
      selectedCategories: [],
      distance: [1, 5, 10, 20, 50, 100],
      openBid: false,
      repeat: false,
      dialog: false,
      detailsDialog: false,
      dialogs: {
        'job-details': false
      },
      sort: 'Distance',
      placeholder: 'Last Search Location',
      loading: null,
      sortOptions: ['Job Total', 'Category', 'Distance', 'Start Date'],
      asc: true,
      show: false,
      model: [],
      thisJob: {},
      catSelectDialog: false,
      gpsFixed: false,
      filterPanel: [],
      listView: false,
      added: false
    }
  },

  mounted () {
    if (localStorage.openBid === undefined ||
        localStorage.repeat === undefined) {
      localStorage.openBid = false

      localStorage.repeat = false
    } else {
      this.openBid = localStorage.openBid === 'true'
      this.repeat = localStorage.repeat === 'true'
    }
    if (localStorage.listView === undefined) {
      this.listView = false
    } else {
      this.listView = localStorage.listView === 'true'
    }
    if (localStorage.sort === undefined) {
      this.sort = 'Distance'
    } else {
      this.sort = localStorage.sort
    }
    if (localStorage.asc === undefined) {
      this.asc = true
    } else {
      this.asc = localStorage.asc === 'true'
    }
    this.$store.dispatch('fetchLocation')
    this.$nextTick(() => {
      this.$refs.searchAdd.$el.value = ((this.userProfile || {}).address || {}).formatted_address
    })
  },

  computed: {
    google: gmapApi,
    ...mapState([
      'userProfile',
      'currentUser',
      'filteredCategories',
      'jobs',
      'location',
      'categories',
      'status',
      'userJobs'
    ]),
    compoundProperty () {
      return [this.filteredCategories, this.jobs, this.sort, this.asc, this.location].join()
    },
    filteredJobs () {
      var jobs = []
      if (this.selectedCategories.length > 0) {
        jobs = this.jobs.filter((job) => {
          return this.selectedCategories.includes(job.category)
        }).filter((job) => {
          if (this.openBid) {
            return job.bid && job.compensation === undefined
          }
          return job
        }).filter((job) => {
          if (this.repeat) {
            return job.repeat
          }
          return job
        })
        if (this.asc) {
          switch (this.sort) {
            case 'Job Total':
              return jobs.sort((a, b) => {
                a.comp = a.compensation ? a.compensation : 0
                b.comp = b.compensation ? b.compensation : 0
                return parseFloat(a.comp) > parseFloat(b.comp) ? 1 : -1
              })
            case 'Category':
              return jobs.sort((a, b) => {
                return a.category > b.category ? 1 : -1
              })
            case 'Distance':
              return jobs.sort((a, b) => {
                return parseFloat(a.dist) > parseFloat(b.dist) ? 1 : -1
              })
            case 'Start Date':
              return jobs.sort((a, b) => {
                return new Date(a.startDate) > new Date(b.startDate) ? 1 : -1
              })
          }
        } else {
          switch (this.sort) {
            case 'Job Total':
              return jobs.sort((a, b) => {
                a.comp = a.compensation ? a.compensation : 0
                b.comp = b.compensation ? b.compensation : 0
                return parseFloat(a.comp) < parseFloat(b.comp) ? 1 : -1
              })
            case 'Category':
              return jobs.sort((a, b) => {
                return a.category < b.category ? 1 : -1
              })
            case 'Distance':
              return jobs.sort((a, b) => {
                return parseFloat(a.dist) < parseFloat(b.dist) ? 1 : -1
              })
            case 'Start Date':
              return jobs.sort((a, b) => {
                return new Date(a.dateUTC) < new Date(b.dateUTC) ? 1 : -1
              })
          }
        }
      }
      return jobs
    },
    mapOptions () {
      if (this.$vuetify.theme.dark) {
        return {
          zoomControl: true,
          mapTypeControl: false,
          // scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
          styles: [
            { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
            {
              featureType: 'administrative.locality',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#d59563' }]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#d59563' }]
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [{ color: '#263c3f' }]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels',
              stylers: [
                {
                  visibility: 'off'
                }
              ]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{ color: '#38414e' }]
            },
            {
              featureType: 'road',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#212a37' }]
            },
            {
              featureType: 'road',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#9ca5b3' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{ color: '#746855' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [{ color: '#1f2835' }]
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#f3d19c' }]
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [{ color: '#2f3948' }]
            },
            {
              featureType: 'transit.station',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#d59563' }]
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [{ color: '#17263c' }]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{ color: '#515c6d' }]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.stroke',
              stylers: [{ color: '#17263c' }]
            }
          ]
        }
      }
      return {
        zoomControl: true,
        mapTypeControl: false,
        // scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dde2e3'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'all',
            stylers: [
              {
                color: '#c6e8b3'
              },
              {
                visibility: 'on'
              }
            ]
          },

          {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#c6e8b3'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#c1d1d6'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#a9b8bd'
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'all',
            stylers: [
              {
                color: '#f8fbfc'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text',
            stylers: [
              {
                color: '#979a9c'
              },
              {
                visibility: 'on'
              },
              {
                weight: 0.5
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on'
              },
              {
                color: '#827e7e'
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#3b3c3c'
              },
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#a6cbe3'
              },
              {
                visibility: 'on'
              }
            ]
          }
        ]
      }
    },
    randLat () {
      var rand = Math.random() * 0.008 - 0.005
      return rand
    },
    randLong () {
      var rand = Math.random() * 0.008 - 0.005
      return rand
    }
  },

  methods: {
    full () {
      var map = document.querySelector('.gm-style')
      map.requestFullscreen()
    },
    processIcon (job) {
      var icon = {
        url: require(`@/assets/map/${job.category}.svg`),
        /* eslint-disable */
        scaledSize: new google.maps.Size(42, 42)
        /* eslint-enable */
      }
      return icon
    },
    processLabel (index) {
      var label = {
        text: index,
        color: 'rgb(255,69,33)',
        fontWeight: 'bold'
      }
      return label
    },
    mapClick (job) {
      this.thisJob = job
      this.$router.push({ path: `/obrero/job-details/${job._key}?tab=Summary` })
      if (document.fullscreenElement) {
        document.exitFullscreen()
      } else if (document.mozFullScreenElement) {
        document.mozCancelFullScreen()
      } else if (document.webkitFullscreenElement) {
        document.webkitExitFullscreen()
      } else if (document.msFullscreenElement) {
        document.msExitFullscreen()
      }
    },
    changeView (val) {
      this.listView = val
    },

    handlePanel () {
      this.filterPanel = this.filterPanel === 0 ? null : 0
    },

    openDialog (data) {
      this.thisJob = data
      this.dialogs['job-details'] = true
    },
    selectAll () {
      if (this.categories.length === this.selectedCategories.length) {
        this.selectedCategories = []
      } else {
        let tempCategories = []
        this.categories.forEach((category) => {
          tempCategories.push(category._key)
        })
        this.selectedCategories = tempCategories
        // Has to be made this ugly because categories is some weird object instead of a plain array of strings
      }
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/public/categories`] = this.selectedCategories
      fb.database.ref().update(updates)
    },

    handleSelectClose () {
      this.catSelectDialog = false
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/public/categories`] = this.selectedCategories
      fb.database.ref().update(updates)
    },

    getJobsfromGPS () {
      this.loading = true
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          this.position = position.coords
          this.$refs.searchAdd.$el.value = 'Current Location'
          var updates = {}
          updates[`user/${this.currentUser.uid}/profile/location/coords`] = [
            position.coords.latitude,
            position.coords.longitude
          ]
          await fb.database.ref().update(updates)
          this.loading = false
          this.gpsFixed = true
        })
      } else {
        this.loading = false
      }
    },
    clear () {
      // this.distance = 0
      this.$refs.searchAdd.$el.value = null
    },

    getAddressData: function (addressData, placeResultData, id) {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/location/coords`] = [
        addressData.geometry.location.lat(),
        addressData.geometry.location.lng()
      ]
      fb.database.ref().update(updates)
    },

    changeDistance () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/location/distance`] = this.location.distance
      fb.database.ref().update(updates)
    }
  },
  watch: {
    'userProfile.categories': {
      handler: function () {
        if (this.userProfile.public) {
          this.selectedCategories = [...(this.userProfile.public.categories || [])] || []
        }
      },
      immediate: true
    },
    openBid () {
      localStorage.openBid = this.openBid
    },
    repeat () {
      localStorage.repeat = this.repeat
    },
    listView () {
      localStorage.listView = this.listView
    },
    sort () {
      localStorage.sort = this.sort
    },
    asc () {
      localStorage.asc = this.asc
    }
  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      var date = new Date(moment(`${val.startDate}T${val.startTime.h} ${val.startTime.mm} ${val.startTime.A}`, ['YYYY-MM-DDTHH.mm a']))
      return moment(date).fromNow()
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    },
    formatDist (val) {
      return val + ' mi.'
    },

    formatTime (val) {
      if (!val) {
        return '-'
      }
      return moment(`${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm A')
    }
  }
}
</script>
<style>
.custom.v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  padding: 0 12px;
  padding-bottom: 12px;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 12px;
}
.v-text-field.v-text-field--enclosed .v-input__append-inner {
  margin-top: 4px;
}
.v-expansion-panel__header {
  padding: 0px 12px;
  padding-bottom: 12px;
}
li a {
  text-decoration: none;
}
</style>
<style scoped>
.custom-input {
  border: 0.5px solid;
  border-color: grey;
}
</style>
// addJob() { // var getRandomLocation = function (latitude, longitude, radiusInMeters) { // var
getRandomCoordinates = function (radius, uniform) { // // Generate two random numbers // var a =
Math.random(), // b = Math.random() // // Flip for more uniformity. // if (uniform) { // if (a>b) {
// var c = b // b = a // a = c // } // } // // It's all triangles. // return [ // b * radius *
Math.cos(2 * Math.PI * a / b), // b * radius * Math.sin(2 * Math.PI * a / b) // ] // } // var
randomCoordinates = getRandomCoordinates(radiusInMeters, true) // // Earths radius in meters via WGS
84 model. // var earth = 6378137 // // Offsets in meters. // var northOffset = randomCoordinates[0],
// eastOffset = randomCoordinates[1] // // Offset coordinates in radians. // var offsetLatitude =
northOffset / earth, // offsetLongitude = eastOffset / (earth * Math.cos(Math.PI * (latitude /
180))) // // Offset position in decimal degrees. // return [ // latitude + (offsetLatitude * (180 /
Math.PI)), longitude + (offsetLongitude * (180 / Math.PI)) // ] // } // var updates = {} // var
newKey = fb.database.ref().child(`jobs`).push().key // var random = getRandomLocation(37.4122553,
-121.953771, 100000) // var thing = { // key: newKey, // location: random // } //
updates[`/jobs/${newKey}`] = thing // fb.database.ref().update(updates) // fb.geoFireApp.set(newKey,
thing.location) // },
